/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota", "Nedjelja"], e = ["Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"], t = "Godine", n = "Godina", o = "Mjesec", s = "Sedmica", r = "Dana", c = "Dan", d = "Danas", j = "Nema događaja", i = "Cijeli dan", l = "Obriši", b = "Kreiraj događaj", m = "dddd D MMMM YYYY", k = {
  weekDays: a,
  months: e,
  years: t,
  year: n,
  month: o,
  week: s,
  days: r,
  day: c,
  today: d,
  noEvent: j,
  allDay: i,
  deleteEvent: l,
  createEvent: b,
  dateFormat: m
};
export {
  i as allDay,
  b as createEvent,
  m as dateFormat,
  c as day,
  r as days,
  k as default,
  l as deleteEvent,
  o as month,
  e as months,
  j as noEvent,
  d as today,
  s as week,
  a as weekDays,
  n as year,
  t as years
};
